import { lazy, Suspense } from "react";

/**
 * ECharts pesa mas que todo el resto de la aplicacion junta. Cargarlo solo
 * cuando aparece el primer grafico deja el arranque del chat ligero para quien
 * nunca pide uno.
 */
const Chart = lazy(async () => {
  const module = await import("./Chart.tsx");
  return { default: module.Chart };
});

export function ChartLazy({ props }: { props: Record<string, unknown> }) {
  return (
    <Suspense
      fallback={
        <div className="rounded-lg border bg-card px-4 py-3 text-sm text-muted-foreground">
          Cargando gráfico…
        </div>
      }
    >
      <Chart props={props} />
    </Suspense>
  );
}
